<template>
  <section class="preview">
    <div class="content" ref="content">
      <div class="label">
        <div class="label-text">
          Dátum: od {{startDate}} do
          <span class="label-text--end">{{endDate}}</span>
        </div>
      </div>
      <div class="main">
        <div class="main-about">
          <div class="main-high animated infinite pulse">Blahoželáme!</div>
          <div class="main-text">Boli ste vybratí zúčastniť sa finančného experimentu:</div>
          <div class="main-medium">"Získajte týždenne 1000 €!"</div>
        </div>
      </div>
    </div>
    <div class="main-info" ref="info" :style="{minHeight: infoHeight + 'px'}">
      <div class="main-info-item">
        <img class="main-info-item__img" src="../assets/img/warning.svg" />
        <div class="main-info-item__text">
          <div class="main-info-item__text--attence">Upozornenie:</div>Dnes je posledný deň, keď máte k dispozícii bezplatnú registráciu!
        </div>
      </div>
      <div class="main-info-item">
        <img class="main-info-item__img" src="../assets/img/wallet.svg" />
        <div
          class="main-info-item__text"
        >Odpovedzte len na 3 jednoduché otázky, aby ste získali dôležité informácie:</div>
      </div>
      <div class="main-button">
        <button class="button" type="button" @click="next">
          <span class="button__text" >Zúčastniť sa</span>
        </button>
      </div>
      <div class="copy">
        <p>
          © {{ new Date().getFullYear()}}. <span class="noaff">ABCMobile OÜ</span> <br>
          Harju maakond, Tallinn, Peterburi tee 71-318, 11415, Estonia. <br>
          Zákaznícky servis: <a href="https://abchelp.me/sk">https://abchelp.me/sk</a>, +421 313215999 <br>
          Pozrite si naše <a href="./terms.php">Obchodné podmienky</a> a <a href="./privacy.php">Zásady ochrany osobných údajov</a>
          <br>
          <span class="noaff">Affiliate: <a href="http://mobstra.com/">mobstra.com</a></span>
        </p>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
@import url('../assets/animation.css');

.copy{
  color: #787878;
  font-size: 11px;
  margin-top: 12px;
  a{
    color: #787878;
  }
}

.label {
  text-align: center;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  max-width: 375px;
  margin: 0 auto;
  &-text {
    color: #203078;
    font-weight: bold;
    font-size: 12px;
    &--end {
      color: #2f9e31;
    }
  }
}
.main {
  max-width: 375px;
  margin: 0 auto;
  background: #203078;
  text-align: center;
  &-about {
    padding: 27px 29px 0 29px;
    @media (min-height: 812px) {
      padding-top: 89px;
    }
  }
  &-high {
    color: #ffffff;
    text-transform: uppercase;
    font-size: 30px;
    font-weight: bold;
  }
  &-text {
    color: #9bacf5;
    font-size: 16px;
    line-height: 19px;
    margin: 16px 0;
    @media (min-height: 812px) {
      margin: 52px 0 33px 0;
    }
  }
  &-medium {
    font-weight: bold;
    font-size: 22px;
    text-transform: uppercase;
    line-height: 28px;
    color: #fff;
  }
  &-info {
    max-width: 375px;
    margin: 0 auto;
    margin-top: 28px;
    text-align: center;
    background: #ffffff;
    border-radius: 20px 20px 0px 0px;
    padding: 14px 10px;
    @media (min-height: 812px) {
      margin-top: 87px;
    }
    &-item {
      text-align: left;
      border: 1px solid #c4c4c4;
      border-radius: 10px;
      padding: 6px 7px;
      min-height: 72px;
      display: flex;
      &:not(:first-child) {
        margin-top: 9px;
      }
      &__img {
        align-self: flex-start;
        margin-right: 7px;
      }
      &__text {
        margin: 5px;
        font-size: 14px;
        line-height: 16px;
        color: #000000;
        &--attence {
          font-weight: 500;
        }
      }
    }
  }
  &-button {
    margin-top: 24px;
  }
}
.button {
  outline: none;
  background: #2f9e31;
  border-radius: 6px;
  border: none;
  border-bottom: 2px solid #2d862f;
  width: 100%;
  max-width: 320px;
  height: 60px;
  padding-top: 2px;
  position: relative;
  padding: 0 15px;
  &__text {
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
  }
  &:after {
    content: url("../assets/img/button-arrow.svg");
    position: absolute;
    right: 14.75px;
    top: calc(50% + 3px);
    transform: translate(0, -50%);
  }
}
</style>


<script>
import moment from 'moment';
export default {
  data() {
    return {
      html: document.getElementById("html"),
      innerHeight: window.innerHeight,
      infoHeight: null,
      endDate: moment().format("DD.MM.YYYY"),
      startDate: moment().subtract(5, 'days').format("DD.MM.YYYY")
    };
  },
  methods: {
    backgroundChganger(color) {
      this.html.style.background = color;
    },
    next() {
      this.$emit("switchScreen", "quiz");
    },
    footerHeight() {
      this.innerHeight = window.innerHeight;
      let outHeight;
      if (this.innerHeight >= 812) {
        outHeight = 155;
      } else {
        outHeight = 96;
      }
      this.infoHeight =
        this.innerHeight - this.$refs.content.clientHeight - outHeight;
    }
  },
  props: ["app"],
  mounted() {
    this.backgroundChganger("#203078");
    window.onresize = () => this.footerHeight();
    this.footerHeight();
  },
  beforeDestroy() {
    this.backgroundChganger("#fff");
  }
};
</script>